import React from 'react'
import { useParams } from 'react-router'
import HeaderTabLayout from '../components/HeaderTabLayout'
import Layout from '../components/Layout'
import Loader from '../components/Loader'
import LeaveTypeView from '../components/version-4/viewForms/LeaveTypeView'
import { useLeaveType } from '../hooks/CompanyConfiguration/useLeaveType'
import { useCategory } from '../hooks/Features/useCategory'
import { useFeatures } from '../hooks/Features/useFeatures'
import { ROUTES } from '../shared/constants'

function ViewLeaveType() {
    const { getLeaveType, leaveType } = useLeaveType()
    const params = useParams()

    React.useEffect(() => {
        getLeaveType({ leaveTypeId: params.leaveTypeId })
    }, [params.leaveTypeId])

    return (
        <Layout heading="Leave Type" heading2="Info" url1={ROUTES.LEAVE_TYPE} none>
            {leaveType ? (
                <HeaderTabLayout
                    heading="Leave Type"
                    content={<LeaveTypeView leaveType={leaveType} />}
                    view
                    url={`/edit-leaveType/${params.leaveTypeId}`}
                />
            ) : <Loader />}
        </Layout>
    )
}

export default ViewLeaveType
